module.exports = __webpack_public_path__ + "public/img/ylzf.7ca2201b.png";